// Copyright (c) 2023 Deere & Company

const duplicatePinPlateSortOptions = [
    {
        displayName: 'SUBMITTED',
        path: ['dateSubmmited']
    }
];

export default duplicatePinPlateSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/duplicate-pin-plate-sort-options.js